

export default function timer(currentTime:number){
    return `
        <div id="quiz-timer">
            <span class="timer-second">
                ${currentTime}.Sec
            </span>
            <div class="timer-progress">
            </div>
        </div>
    `;
}